import { render, staticRenderFns } from "./InstallAppWrap.vue?vue&type=template&id=2d27d22f"
import script from "./InstallAppWrap.vue?vue&type=script&lang=js"
export * from "./InstallAppWrap.vue?vue&type=script&lang=js"
import style0 from "./InstallAppWrap.vue?vue&type=style&index=0&id=2d27d22f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports